var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarrating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0036 0.728847L6.73624 5.32607L1.66332 6.06565C0.753597 6.1976 0.389014 7.31912 1.04874 7.96149L4.71887 11.5379L3.85082 16.59C3.69457 17.5031 4.65638 18.1872 5.46193 17.7601L10.0001 15.3747L14.5383 17.7601C15.3439 18.1837 16.3057 17.5031 16.1494 16.59L15.2814 11.5379L18.9515 7.96149C19.6112 7.31912 19.2467 6.1976 18.3369 6.06565L13.264 5.32607L10.9967 0.728847C10.5904 -0.0905971 9.41332 -0.101014 9.0036 0.728847Z",
    fill: "#F9C32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarrating);
export default __webpack_public_path__ + "static/media/Starrating.7946f974765051d611df6965058d32e4.svg";
export { ForwardRef as ReactComponent };